module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAYAAAA7bUf6AAABGklEQVQ4T6XUsU7CUBQG4P9ASgoy+BS8BmFwdnNQlsvSyKLu4DuQ6NAYrQwYw+YEg448CvEJQIG2x9wmtyntveUSOzVp+/U//2lK+McRBIErhPil0fOkgyr33c3q0vO8na35MH5vRXE4D7naJt/3nU2tMY0B1LfrCxtIAmEcfTJwfyeuXkm++RgoD8jnE8QW0gF7iIJ+ao2pPM+PZgIKiAlKSozCr5hoKDvIl5+Ok70gO1KJKOIhKpWZCdAm2evIOflg4IwJ/VvRfTKtX5tE3qxGAOGbwcuy9WuRFAAG7m71ZipbJSsgWeCm1x0f2lqhEx2Q7ciUKE1SBhyCEsQGKIPoGMAE0ehlcg7wqSrR9leQfJBO/XrRdB//AGHY8n1GvRlJAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/static/images/closeicon.png
// module id = Nr51
// module chunks = 1